import { FC } from 'react';
import { ICON_SETTLEMENT_BOOKMARK } from 'assets/icons';
import Column from 'components/common/Column';
import Text from 'components/common/Text';

interface Props {
  textContent: string | React.ReactNode;
  style?: React.CSSProperties;
}

const EmptySettlement: FC<Props> = props => {
  const { textContent, style } = props;

  return (
    <Column gap="12px" style={{ minHeight: '30vh', ...style }}>
      <img src={ICON_SETTLEMENT_BOOKMARK} alt="settlement bookmark" />
      <Text color="#46474c" size="14px" weight={400}>
        {textContent}
      </Text>
    </Column>
  );
};

export default EmptySettlement;
